module.exports = (__parcel__import__("kj1yG")).then(() => parcelRequire('4MKVl'));